import React, { Children } from 'react';
import { motion } from 'framer-motion';
const GOLD = '#d8b878';
export function CTA() {
  return <section className="relative overflow-hidden bg-matrix-black py-16 md:py-24 px-5 md:px-8 border-t border-matrix-green/15" data-id="element-47">
      {/* Subtle portal of light — a bridge into the offer */}
      <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden" data-id="element-48">
        <motion.div className="absolute left-1/2 top-[40%] h-[45vh] w-[45vh] -translate-x-1/2 -translate-y-1/2 rounded-full blur-3xl" style={{
        background: 'radial-gradient(circle, rgba(216,184,120,0.16) 0%, rgba(0,255,65,0.06) 42%, transparent 70%)'
      }} animate={{
        opacity: [0.5, 0.85, 0.5],
        scale: [0.96, 1.04, 0.96]
      }} transition={{
        duration: 7,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-49" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_transparent_45%,_rgba(0,0,0,0.78)_100%)]" data-id="element-50"></div>
      </div>

      <div className="relative z-10 max-w-2xl mx-auto text-center" data-id="element-51">
        <motion.span initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="inline-block font-inter text-[10px] md:text-xs tracking-[0.4em] uppercase mb-6" style={{
        color: 'rgba(216,184,120,0.7)'
      }} data-id="element-52">
          El llamado
        </motion.span>

        <motion.h2 initial={{
        opacity: 0,
        y: 22
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.05
      }} className="font-cinzel text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-matrix-cream leading-[1.25] mb-8 md:mb-10 drop-shadow-[0_0_22px_rgba(245,230,200,0.18)]" data-id="element-53">
          La pregunta no es si la vida tiene reglas.{' '}
          <span className="italic" style={{
          color: GOLD,
          textShadow: '0 0 30px rgba(216,184,120,0.4)'
        }} data-id="element-54">
            La pregunta es si estás listo para verlas.
          </span>
        </motion.h2>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.14
          }
        }
      }} className="space-y-4 md:space-y-5 text-[15px] md:text-lg text-matrix-white/80 font-light leading-[1.9]" data-id="element-55">
          <motion.p variants={{
          hidden: {
            opacity: 0,
            y: 14
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.6
            }
          }
        }} data-id="element-56">
            Puedes seguir viviendo desde el personaje que aprendiste a ser. O
            puedes detenerte, observar y empezar a reconocer que dentro de ti ya
            existe una conciencia capaz de mirar más allá del miedo, la rutina y
            las creencias heredadas.
          </motion.p>
          <motion.p variants={{
          hidden: {
            opacity: 0,
            y: 14
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.6
            }
          }
        }} className="text-matrix-white/65 italic" data-id="element-57">
            Este ebook no es para todos. Es para quien siente que algo dentro de
            sí ya empezó a despertar.
          </motion.p>
        </motion.div>

        {/* Highlighted closing call — bridge to the offer */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="mt-10 md:mt-12" data-id="element-58">
          <div className="w-px h-9 bg-gradient-to-b from-transparent via-[rgba(216,184,120,0.5)] to-transparent mx-auto mb-6" data-id="element-59"></div>
          <p className="font-cinzel italic text-xl sm:text-2xl md:text-3xl leading-[1.4]" style={{
          color: GOLD,
          textShadow: '0 0 26px rgba(216,184,120,0.5), 0 0 60px rgba(216,184,120,0.2)'
        }} data-id="element-60">
            Cuando empiezas a ver el tablero, ya no puedes seguir jugando igual.
          </p>
        </motion.div>
      </div>
    </section>;
}